import changeDomainBR from './changeDomain.br';
import changeDomainCL from './changeDomain.cl';
import changeDomainCO from './changeDomain.co';
import changeDomainMX from './changeDomain.mx';
import changeDomainAR from './changeDomain.ar';

const locales = {
  BR: changeDomainBR,
  CL: changeDomainCL,
  CO: changeDomainCO,
  MX: changeDomainMX,
  AR: changeDomainAR,
};

export default locales;
